import { axios } from '../../services/axios';
import { query } from '../../utils/utils';
export default function getGCCHServiceProfileVoicePolicies({ scope, regions }) {
    return axios.get(
        `/ServiceProfiles/DirectRoutingGCCH/${scope}/VoicePolicies/Available?RegionIDs=${query(
            regions,
        )}`,
    );
}
